import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "layout": "simple",
  "title": "Nutzungsbedingungen",
  "lead": ""
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h3: "h3",
    li: "li",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Title} = _components;
  if (!Title) _missingMdxReference("Title", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Title, {
      padded: true,
      children: "Nutzungsbedingungen "
    }), "\n", _jsx(_components.p, {
      children: "Der Weltbildungsbericht hält zur Nutzung der Website Scoping Progress in Education (SCOPE) zu rein informativen Zwecken an. Alle Inhalte dieser Website sind urheberrechtlich geschützt. Durch den Besuch der Website und die Nutzung jeglicher darauf befindlicher Inhalte stimmen Sie (die „Nutzerin“/der „Nutzer“) zu, dass Sie diese Nutzungsbedingungen vollständig gelesen und verstanden haben und sich einverstanden erklären, daran gebunden zu sein."
    }), "\n", _jsxs(_components.p, {
      children: ["Die auf dieser Website verfügbaren Informationen wurden in der Absicht veröffentlicht, für die persönliche oder öffentliche nicht-kommerzielle Nutzung leicht verfügbar zu sein. Sie können vollständig oder teilweise und auf jegliche Weise reproduziert werden, ohne dass dafür Gebühren anfallen oder weitere Genehmigungen erforderlich wären, wenn nicht anders angegeben. Jegliche Anfragen hinsichtlich kommerzieller Nutzung und Übersetzungsrechten senden Sie bitte an:", _jsx(_components.a, {
        href: "mailto:gemreport@unesco.org",
        children: "gemreport@unesco.org"
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "die-nutzerinnen-und-nutzer-sind-aufgefordert",
      children: "Die Nutzerinnen und Nutzer sind aufgefordert:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Mit äußerster Sorgfalt dafür zu sorgen, dass reproduzierte Materialien fehlerfrei sind;"
      }), "\n", _jsx(_components.li, {
        children: "Die Quelle gut sichtbar neben den Daten in folgendem Format anzugeben:"
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Quelle: (Falls zutreffend „adaptiert aus“) GEM Report Scoping Progress in Education (SCOPE) website, ", _jsx(_components.a, {
        href: "https://www.education-progress.org",
        children: "https://www.education-progress.org"
      }), ", Datum des Abrufs."]
    }), "\n", _jsx(_components.p, {
      children: "Es ist darauf hinzuweisen, dass der Datenbestand regelmäßig aktualisiert und überarbeitet wird. Daher ist es wichtig, beim Zitieren von Angaben das Abrufdatum anzugeben."
    }), "\n", _jsx(_components.h3, {
      id: "lizenzen",
      children: "Lizenzen"
    }), "\n", _jsx(_components.p, {
      children: "Sie sind dazu angehalten, die Daten zu Ihrem eigenen Nutzen und dem anderer auf kreative Weise zu verwenden. Sie können die in den Datensätzen enthaltenen Informationen entnehmen, herunterladen und kopieren. Zudem können Sie diese Informationen mit Dritten teilen."
    }), "\n", _jsx(_components.h3, {
      id: "ausschluss-von-zugehörigkeit-oder-befürwortung",
      children: "Ausschluss von Zugehörigkeit oder Befürwortung"
    }), "\n", _jsx(_components.p, {
      children: "Die Nutzerin oder der Nutzer darf es weder so darstellen noch andeuten, dass der Weltbildungsbericht an ihrer oder seiner Nutzung beziehungsweise Reproduktion des Materials beteiligt war, diese genehmigt, befürwortet oder anderweitig unterstützt hat. Die Nutzerin oder der Nutzer darf keinerlei Zugehörigkeit zur Website Fortschritte im Bildungsbereich (oder dem Weltbildungsbericht) behaupten."
    }), "\n", _jsx(_components.h3, {
      id: "website-links",
      children: "Website-links"
    }), "\n", _jsx(_components.p, {
      children: "Eine externe Website kann einen Hyperlink zu einer Seite dieser Website Fortschritte im Bildungsbereich enthalten, ohne die Erlaubnis dafür eingeholt zu haben. Dadurch dürfen jedoch die geistigen Eigentumsrechte des Weltbildungsberichts, insbesondere in Bezug auf Namen, Logos, Urheber- und Autorenrechte, nicht verletzt werden."
    }), "\n", _jsx(_components.h3, {
      id: "haftungsausschluss",
      children: "Haftungsausschluss"
    }), "\n", _jsx(_components.p, {
      children: "Der Weltbildungsbericht unterhält diese Website, um den öffentlichen Zugang zu Daten und damit zusammenhängenden Informationen zu stärken. Er bemüht sich nach Kräften, die Richtigkeit und Vollständigkeit der Informationen auf dieser Website zu gewährleisten, garantiert diese jedoch nicht. Unser Ziel ist es, diese Informationen zeitnah und akkurat zu halten. Sollten wir auf Fehler hingewiesen werden, bemühen wir uns, diese zu korrigieren."
    }), "\n", _jsx(_components.p, {
      children: "Die verwendeten Bezeichnungen und die Präsentation der Inhalte auf dieser Website stellen keinerlei Meinungsäußerung seitens der UNESCO hinsichtlich des Rechtsstatus eines Landes, eines Territoriums, einer Stadt, eines Gebietes, deren Behörden oder von Grenzverläufen dar."
    }), "\n", _jsx(_components.p, {
      children: "Der Global Education Monitoring Report trägt die Verantwortung für die Auswahl und Präsentation der auf dieser Website enthaltenen Fakten, die nicht unbedingt der Meinung der UNESCO entsprechen und die Organisation in keiner Weise verpflichten."
    }), "\n", _jsx(_components.p, {
      children: "Wir bemühen uns, durch technische Fehler verursachte Störungen zu minimieren. Es ist jedoch möglich, dass Daten oder Informationen auf der Website in Dateien oder Formaten erstellt oder strukturiert wurden, die nicht fehlerfrei sind, und wir können nicht garantieren, dass unser Service durch derlei Probleme nicht unterbrochen oder anderweitig beeinträchtigt wird. Der Weltbildungsbericht übernimmt keine Haftung für die Probleme (Leistungsausfall, Computervirus, Ausfall von Kommunikationsleitungen, Änderung von Inhalten usw.), die infolge der Nutzung der Website SCOPE oder eines Links zu externen Websites auftreten."
    }), "\n", _jsx(_components.h3, {
      id: "datenschutz",
      children: "Datenschutz"
    }), "\n", _jsx(_components.p, {
      children: "Wenn Sie auf die Website SCOPE zugreifen, werden bestimmte Informationen, wie IP-Adressen, Navigationsverhalten auf der Website, genutzte Software und Dauer des Besuchs neben anderen ähnlichen Informationen auf unseren Servern gespeichert. Diese Informationen identifizieren Sie nicht ausdrücklich, sie werden vielmehr zur Analyse unserer Websitenutzung verwendet."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
